import STApi from '@/api/st';

const SubsDirectChangeApi = {
  /**
   * 즉시변경 구독아이템 조회
   * */
  getDirectChangeTargetList: async (data) => {
    try {
      const response = await STApi.post(
        `/api/subscription_api.php?type=GetDirectChangeEventTargetList`,
        data,
      );
      return response;
    } catch (e) {
      console.error(e);
      return e;
    }
  },
};

export default SubsDirectChangeApi;
